  <template>
    <div class="wui-container coupon_rule">
        <div v-if="lang == 'zh'">
            <h5>一、定义</h5>
            <p>Wellcee优惠券（以下简称“优惠券”）是指用户Wellcee平台内领取的、在购买相关服务时可用于抵扣且有一定金额门槛的优惠工具。获得优惠券的用户可在券面有效期内购买指定服务时, 享受优惠券展示的折扣优惠。</p>

            <h5>二、使用规则</h5>
            <ul>
                <li>领取方式: 用户可通过票券进入优惠券领取页面领取优惠券。</li>
                <li>领取限制: 有效期内, 每张优惠券同一用户领取上限为一次。</li>
                <li>优惠券有效期: 优惠券自领取之日起开始生效, 过期时间以优惠券展示的过期时间为准, 逾期未使用则优惠券自动失效。</li>
                <li>优惠券面额: 优惠券使用门槛及可抵扣金额以实际发放为准。</li>
                <li>优惠券使用范围: 用户需在优惠券有效期内购买指定服务并达到一定的金额门槛后才可使用, 用户可通过点击券右侧“去使用”按钮, 跳转至可用服务页, 购买可用服务进行使用。</li>
                <li>叠加规则: 优惠券与其他优惠券、抵用金均不可叠加。</li>
                <li>优惠券使用限制: 每张券的权益不可拆分, 不得提现, 不得转赠他人。</li>
            </ul>

            <h5>三、退款a规则</h5>
            <p>用户使用优惠券进行抵扣后发生订单内全部服务退款的, 如优惠券仍在有效期内, 则优惠券会退回至用户票券包内; 发生部分服务退款的, 优惠券不退还。</p>

            <h5>四、查询方式</h5>
            <p>用户可通过“Wellcee-我的-票券-优惠券”查看优惠券领取情况及其使用状态。</p>

            <h5>五、注意事项</h5>
            <p>当用户或交易订单存在以下情形的,Wellcee有权取消用户前述优惠券领取资格, 必要时有权追究法律责任:</p>
            <ul>
                <li>盗刷、倒卖、批量机器作弊等不正当或其他影响消费者公平机会的行为;</li>
                <li>用户出现违反规则的行为 (如作弊领取、恶意套现、刷取信誉、虚假交易等);</li>
                <li>欠缺交易意愿，利用优惠券发放流程以实现获取优惠券为目的，购买商品后主动出现大量退款;</li>
                <li>其他经合理判断，以获得优惠券为目的，欠缺交易意愿的行为。</li>
            </ul>

            <p>如出现不可抗力或情势变更的情况 (包括但不限于重大灾害事件受政府机关指令需要停止开展或调整的、遭受严重网络攻击或因系统故障需要暂停开展的)，则Wellcee可依相关法律法规的规定主张免责。</p>
        </div>

        <div v-if="lang == 'en'">
            <h5>Definition</h5>
            <p>Wellcee Coupons (hereinafter referred to as "Coupons") refer to discount tools obtained by users on the Wellcee platform. These coupons can be used to offset payments when purchasing specified services, subject to a minimum spending amount. Users who acquire coupons can enjoy the displayed discount within the validity period for specified services.</p>

            <h5>Rules of Use</h5>
            <ul>
                <li>How to Claim: Users can claim coupons through the coupon display page.</li>
                <li>Claim Limit: Each user can claim the same coupon only once during its validity period.</li>
                <li>Validity Period: Coupons become active when claiming, and their expiration date is as shown on the coupon. Unused coupons will automatically expire.</li>
                <li>Coupon Value: The discount threshold and applicable amount depend on the specific coupon issued.</li>
                <li>Usage Scope: Coupons can be used only to purchase specified services within their validity period, provided the minimum amount threshold is met. Users can click "Use Now" on the coupon page to view eligible services and make a purchase.</li>
                <li>Stacking Rules: Coupons cannot be stacked with other discounts or credits.</li>
                <li>Usage Restrictions: Each coupon is indivisible, non-cashable, and non-transferable.</li>
            </ul>

            <h5>Refund Policy</h5>
            <p>Full Refund: If a full refund is issued for an order where a coupon was applied and the coupon is still valid, the coupon will be returned to the user's account.</p>
            <p>Partial Refund: For partial refunds, the coupon will not be returned.</p>

            <h5>How to Check</h5>
            <p>Users can view the status and details of their coupons under "Wellcee - Me - Tickets - Coupon"</p>

            <h5>Notes</h5>
            <p>Wellcee reserves the right to revoke coupon eligibility and pursue legal action if the user or transaction exhibits any of the following behaviors:</p>
            <ul>
                <li>Fraudulent activities such as interface exploitation, reselling, or automated abuse that harm fair consumer opportunities.</li>
                <li>Rule violations, such as fraudulent claims, cashing out, reputation manipulation, or false transactions.</li>
                <li>Lack of genuine purchase intent, including repeated refunds to exploit coupon distribution.</li>
                <li>Other behaviors aimed at acquiring coupons without genuine intent to purchase.</li>
            </ul>

            <p>In cases of force majeure or significant changes in circumstances (e.g., major disasters, government directives, severe network attacks, or system failures), Wellcee may claim exemption in accordance with relevant laws and regulations.</p>
        </div>

        <div v-if="lang == 'tw'">
            <h5>一、定義</h5>
            <p>Wellcee優惠券（以下簡稱「優惠券」）是指用戶Wellcee平台內領取的、在購買相關服務時可用於抵扣且有一定金額門檻的優惠工具。獲得優惠券的用戶可在券面有效期內購買指定服務時，享受優惠券展示的折扣優惠。</p>

            <h5>二、使用規則</h5>
            <ul>
                <li>領取方式： 用戶可通過票券進入優惠券領取頁面領取優惠券。</li>
                <li>領取限制： 有效期內，每張優惠券同一用戶領取上限為一次。</li>
                <li>優惠券有效期： 優惠券自領取之日起開始生效，過期時間以優惠券展示的過期時間為準，逾期未使用則優惠券自動失效。</li>
                <li>優惠券面額： 優惠券使用門檻及可抵扣金額以實際發放為準。</li>
                <li>優惠券使用範圍： 用戶需在優惠券有效期內購買指定服務並達到一定的金額門檻後才可使用，用戶可通過點擊券右側「去使用」按鈕，跳轉至可用服務頁，購買可用服務進行使用。</li>
                <li>疊加規則： 優惠券與其他優惠券、抵用金均不可疊加。</li>
                <li>優惠券使用限制： 每張券的權益不可拆分，不得提現，不得轉贈他人。</li>
            </ul>

            <h5>三、退款規則</h5>
            <p>用戶使用優惠券進行抵扣後發生訂單內全部服務退款的，如優惠券仍在有效期內，則優惠券會退回至用戶票券包內；發生部分服務退款的，優惠券不退還。</p>

            <h5>四、查詢方式</h5>
            <p>用戶可通過「Wellcee-我的-票券-優惠券」查看優惠券領取情況及其使用狀態。</p>

            <h5>五、注意事項</h5>
            <p>當用戶或交易訂單存在以下情形的，Wellcee有權取消用戶前述優惠券領取資格，必要時有權追究法律責任：</p>
            <ul>
                <li>盜刷、倒賣、批量機器作弊等不正當或其他影響消費者公平機會的行為；</li>
                <li>用戶出現違反規則的行為（如作弊領取、惡意套現、刷取信譽、虛假交易等）；</li>
                <li>欠缺交易意願，利用優惠券發放流程以實現獲取優惠券為目的，購買商品後主動出現大量退款；</li>
                <li>其他經合理判斷，以獲取優惠券為目的，欠缺交易意願的行為。</li>
            </ul>

            <p>如出現不可抗力或情勢變更的情況（包括但不限於重大災害事件受政府機關指令需要停止開展或調整的、遭受嚴重網絡攻擊或因系統故障需要暫停開展的），則Wellcee可依相關法律法規的規定主張免責。</p>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { useRoute } from "vue-router";

export default {
    data() {
        return {
            email: 'maxim@wellcee.com',
            lang: '',
        };
    },
    mounted() {
        const route = useRoute();
        this.lang = ['zh', 'en', 'tw'].includes(route.query.lang) ? route.query.lang : 'zh';
        if (route.query.theme == 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
        if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
            this.$i18n.locale = route.query.lang
        }
        document.title = this.$t('coupon_rule.title');
    },
    methods: {
        
    },
};
</script>

<style scoped>
.coupon_rule{
    box-sizing: border-box;
    min-height: 100vh;
    overflow: hidden;
    padding: 30px;
    background-color: var(--wlc-bg-white);
    font-size: 14px;
    color: #666666;
    line-height: 21px;
}
.coupon_rule h5{
    font-size: 14px;
    font-weight: bold;
    margin: 20px 0 6px 0;
}
.coupon_rule h5:first-child{
    margin-top: 0;
}
.coupon_rule p{
    margin: 6px 0;
}
.coupon_rule ul{
    list-style: decimal;
    list-style-position: inside;
}
.coupon_rule ul li{
    margin: 6px 0;
}
</style>
